module.exports = __webpack_public_path__ + "static/join_wide-288c333eb860e8ac9a2b548826cf22de.png";